import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '1',
  title: 'Audit',
  desc: "Extract your highest-value 'Outcome Assets' from your career history."
}, {
  num: '2',
  title: 'Target',
  desc: "Identify companies with urgent 'Pain Signals' who have the budget to pay you."
}, {
  num: '3',
  title: 'Pivot',
  desc: 'Deploy the Anti-Resume and close your first $5k+ retainer in 30 days or less.'
}];
export function HowItWorksSection() {
  return <section className="py-24 bg-zinc-900/50 border-t border-zinc-900 overflow-hidden" data-id="element-69">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-70">
        <div className="text-center mb-20" data-id="element-71">
          <h2 className="font-display text-4xl md:text-5xl text-zinc-100" data-id="element-72">
            HOW IT <span className="text-teal-500" data-id="element-73">WORKS</span>
          </h2>
        </div>

        <div className="relative" data-id="element-74">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-zinc-800 border-t border-dashed border-zinc-700" data-id="element-75" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-76">
            {steps.map((step, index) => <motion.div key={step.num} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2
          }} className="flex flex-col items-center text-center" data-id="element-77">
                <div className="w-24 h-24 rounded-full bg-zinc-950 border-4 border-teal-500/20 flex items-center justify-center mb-8 relative shadow-[0_0_30px_rgba(20,184,166,0.1)]" data-id="element-78">
                  <span className="font-display text-4xl text-teal-400" data-id="element-79">
                    {step.num}
                  </span>
                </div>
                <h3 className="font-display text-2xl text-zinc-100 mb-4 tracking-wide" data-id="element-80">
                  {step.title}
                </h3>
                <p className="text-zinc-400 leading-relaxed" data-id="element-81">{step.desc}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}